<template>
    <div>
        <input ref="vttinput"
               type="text"
               @input="keyDown($event)"
               class="form-control form-control-sm"
               :value="displayvalue"
               @blur="validateTimeInput()"
               :tabindex="tabindex"
               :placeholder="'5:00'"
               :disabled="disabled"
               autocomplete="off">
    </div>
</template>
<script>



    export default {

        mixins: [],
        props: {
            value: {
                type: String | null,
                required: true
            },
            disabled: {
                type: Boolean,
                required: false
            },
            limit_amount: {
                type: Number,
                required: false
            },
            cssclass: {
                type: String,
                required: false
            },
            tabindex: {},
            change_zero_to_limit: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data: function () {
            return {
                error: false,
                tempvalue: null,
                focussed: false,
            }
        },

        computed: {
            displayvalue: function () {

                if (!this.value){
                    return null;
                }

                return this.minTommss(this.value / 60);

                // if (timeinput.isValid()) {
                //     const vttDate = moment(this.vtt_date);
                //
                //     if(vttDate.isSame(timeinput, 'day')){
                //         return timeinput.format('HH:mm');
                //     }
                //
                //     if(timeinput.hour() === 0 && timeinput.minute() === 0){
                //         return '24:00'
                //     }
                //
                //     return null;
                // }

            }
        },

        mounted() {

        },

        components: {},

        watch: {
            value: function () {
                // console.log('value changed watcher : ' + this.value);
                // this.setDisplayValue(this.value);
            },

        },

        methods: {

            minTommss(minutes){
                var sign = minutes < 0 ? "-" : "";
                var min = Math.floor(Math.abs(minutes));
                var sec = Math.floor((Math.abs(minutes) * 60) % 60);
                return sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec;
            },


            timeInputToMinutes: function (modifiedValue) {
                let splittime = modifiedValue.split(':');

                let minutesFromHours = parseInt((splittime[0] * 60));
                let minutes = parseInt(splittime[1]);
                let totalminutes = minutesFromHours + minutes;

                if (!isNaN(totalminutes)) {
                    this.$emit('input', totalminutes)
                } else {
                    this.error = true;
                    this.$emit('input', null);
                }
            },

            keyDown(event) {

                let typedvalue = event.target.value;

                // replace al non numeric chars by space. exluding the:
                typedvalue = typedvalue.replace(/[,.]/g, ':');
                typedvalue = typedvalue.replace(/[^0-9:]/g, '');  // replace the dot and comma by a :

                this.tempvalue = typedvalue;

                if (typedvalue.charAt(0) === ':') {
                    this.tempvalue = ''
                }

                // check if there is a limit set. If so append a : after the limit has been reached. but only do this when we do not have hit the backspace btn
                if (typedvalue.length === 4 && !typedvalue.includes(':') && event.inputType !== 'deleteContentBackward') {
                    this.tempvalue = typedvalue + ':';
                }

                this.$refs['vttinput'].value = this.tempvalue;
            },

            //validates the field on blur..
            validateTimeInput: function () {
                let value = this.tempvalue;
                this.error = false;


                // if nothing is filled in at the blur. we got undefined. set to null then.
                if (value === undefined || value === null) {
                    this.tempvalue = null;
                    return;
                }

                /** if we have a dot or a comma. we divide it.  */
                if (value.length !== 0 && (value.includes('.') || value.includes(','))) {
                    if (value.includes(',')){
                        value = value.replace(',','.');
                    }
                    value = this.minTommss(value);
                    // if we lose focus on the input and we dont have a divider (:). add it with zero's
                } else if (value.length !== 0 && !value.includes(':')) {
                    if (value > parseInt(this.limit_amount)) {
                        value = parseInt(this.limit_amount);
                    }
                    value = value + ':00';

                } else if (value.length > 2 && value.includes(':')) {

                    let split_for_time = value.split(':');

                    let hours = parseFloat(split_for_time[0]);

                    let minutes = split_for_time[1];

                    if (minutes.length === 0) {
                        minutes = '00';
                    } else if (minutes.length === 1) {
                        minutes = minutes + '0';
                    }


                    /** In most cases this is show an error when the user wants to declare more then 24 hours a day */
                    if (hours > parseInt(this.limit_amount)) {
                        minutes = '00';
                        this.error = true;
                        this.$emit('inputHasError');
                        return;

                    }

                    // if hours higher the the given limit and minutes higher than zero.. just make 24:00
                    if (hours >= parseInt(this.limit_amount) && parseFloat(minutes) > 0) {
                        hours = this.limit_amount.toString();
                        minutes = '00';
                    }

                    if (minutes > 59) {
                        minutes = '59';
                    }


                    if (minutes.length > 2) {
                        minutes = minutes.substr(0, 2)
                    }

                    value = hours + ':' + minutes
                } else {
                    // if the given value is empty and we have had an value in this compo. set it to 0.00 and save. (instead of error)
                    if (value === '' && this.value !== '') {
                        value = '0:00';
                    }
                }

                this.timeInputToMinutes(value);

                this.tempvalue = value;

            },
        },
    }

</script>
